var Mustache = require("mustache");
import Swiper from "swiper";
import swiperA11y from "./utils/swiperA11y";
import breakpointChecker from "./utils/breakpointChecker";
import config from "./utils/config";
import fundDetailTab from "./components/fundDetailTab";

(function ($) {
  if ($(".page--fixedIncome").length > 0) {
    fundDetailTab();
    window.Sharer.init({
      callbackAPI: `fixedIncomeCard__slider`,
    });
    let swiper = {};
    const enableSwiper = function (id) {
      if (
        $(`.fixedIncomeCard__slider__${id} .fixedIncomeCard__slide`).length > 3
      ) {
        $(`.fixedIncomeCard__slider__${id} .swiper-buttons`).show();
      } else {
        $(`.fixedIncomeCard__slider__${id} .swiper-buttons`).hide();
      }
      $(`.fixedIncomeCard__slider__${id}`).removeClass(
        "fixedIncomeCard__slider--static"
      );
      let _swiper = new Swiper(`.fixedIncomeCard__slider__${id}`, {
        autoplay: false,
        loop: false,
        grabCursor: true,
        watchSlidesVisibility: true,
        pagination: {
          el: `.fixedIncomeCard__slider__${id} .swiper-pagination`,
          type: "bullets",
          clickable: true,
        },
        breakpoints: {
          320: {
            autoHeight: true,
            slidesPerView: 1,
            spaceBetween: 10,
          },
          // when window width is >= 992px
          992: {
            autoHeight: true,
            slidesPerView: id == "2" ? 2 : 3,
            spaceBetween: 30,
          },
        },
        navigation: {
          nextEl: `.fixedIncome__${id} .swiper-button-next`,
          prevEl: `.fixedIncome__${id} .swiper-button-prev`,
        },
        init: false,
        observer: true,
        observeParents: true,
        on: {
          init: function () {
            swiperA11y.toggleAriaHidden(_swiper, false);
          },
        },
        // ARIA
        a11y: {
          prevSlideMessage:
            $(".hsvm-i18nKeys-common").data("swiperprevslidemessage") ||
            "Previous slide",
          nextSlideMessage:
            $(".hsvm-i18nKeys-common").data("swipernextslidemessage") ||
            "Next slide",
          paginationBulletMessage:
            $(".hsvm-i18nKeys-common").data("swiperpaginationbulletmessage") ||
            "Go to slide {{index}}",
        },
      });

      _swiper.init();

      _swiper.on("transitionStart", function () {
        swiperA11y.toggleAriaHidden(_swiper, false);
      });
      swiper[id] = _swiper;
    };

    function destroySwiper(id) {
      if (!!swiper[id]) {
        swiper[id].destroy(true, true);
      }
      if (
        $(`.fixedIncomeCard__slider__${id} .fixedIncomeCard__slide`).length > 3
      ) {
        $(`.fixedIncomeCard__slider__${id} .swiper-buttons`).show();
      } else {
        $(`.fixedIncomeCard__slider__${id} .swiper-buttons`).hide();
      }
      $(`.fixedIncomeCard__slider__${id}`).addClass(
        `fixedIncomeCard__slider--static`
      );
      $(`.fixedIncomeCard__slider__${id} .fixedIncomeCard__slide`)
        .removeAttr("aria-hidden")
        .find("a, button")
        .removeAttr("tabindex");
      $(`.fixedIncomeCard__slider__${id}`)
        .removeAttr("aria-hidden")
        .find("a, button")
        .removeAttr("tabindex");
    }

    //enableSwiper(1);
    enableSwiper(2);

    const onResize = function () {
      $(".fixedIncomeCard__cover iframe").width("100%");
      $(".fixedIncomeCard__cover iframe").height(function () {
        return ($(".fixedIncomeCard__cover iframe").width() * 407) / 615;
      });
    };
    onResize();
    $(window).on("resize", onResize);
  }
})(hsvmJQuery);
